import axios from "axios";
import storageService from "./storageService";
// import authService from "./authService";
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  // headers: {
  //   "Content-Type": "application/json",
  //   "X-Requested-With": "XMLHttpRequest",
  // },
});
instance.interceptors.request.use(
  (config) => {
    const token = storageService.getLocalToken();
    const username = storageService.getUserName();
    const user_type = storageService.getUserType();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
      config.headers["username"] = username;
      config.headers["user_type"] = user_type;
      // config.headers["x-access-token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  (res) => {
    // if (res.data.status == "error" && res.data.message == "Unauthorized")
    //   authService.logout();
    return res;
  },
  async (err) => {
    let originalConfig = err.config;
    if (originalConfig === undefined) originalConfig = { url: "" };
    if (originalConfig.url !== "/auth/login" && err.response) {
      // Access Token was expired
      console.log(err);
      if (err.response.status === 401 || !originalConfig._retry) {
        // authService.logout();
        // originalConfig._retry = true;
        // try {
        //   const rs = await instance.post(
        //     "/auth/token",
        //     {
        //       refreshToken: storageService.getLocalRefreshToken(),
        //     },
        //     {
        //       username: storageService.getUserName(),
        //     }
        //   );
        //   const { accessToken } = rs.data;
        //   storageService.updateLocalAccessToken(accessToken);
        //   return instance(originalConfig);
        // } catch (_error) {
        //   return Promise.reject(_error);
        // }
      }
    }
    return Promise.reject(err);
  }
);
export default instance;
